/**
 * スクロールアニメーション
 */

export default class ScrollAnimation {
  constructor() {
    this.attr = 'data-scroll-anima';
    this.targets = document.querySelectorAll(`[${this.attr}]`);
    if (!this.targets.length) return;
    this.init();
  }

  /**
   * スクロールアニメーション対象となる要素を監視
   */
  observer() {
    // 交差した時に属性値を変える
    const doWhenIntersect = entries => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.setAttribute(this.attr, 'true');
        }
      }
    }
    const options = {
      root: null,
      rootMargin: '-10% 0px', // 画面内に20%入ったら
      threshold: 0
    }
    // 監視実行
    const observer = new IntersectionObserver(doWhenIntersect, options);
    this.targets.forEach(target => {
      observer.observe(target);
    });
  }

  init() {
    this.observer();
  }
}
